<template>
  <div>
    <div v-if="!isAnonymous">
      <capture />
    </div>
  </div>
</template>

<script>

import Capture from "./Capture.vue";
// import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    'capture': Capture
    },
    data() {
        return {
          isAnonymous: false,
          onboarded: false
        };
    },
    computed: {
    },
    mounted() {
      // this.onboarded = this.$parent.account[0].onboarded
      // this.currentAccount = this.account[0]
    },
    watch: {
    },
    methods: {
    }
}
</script>

<style scoped></style>
